import React from 'react';
import PropTypes from 'prop-types';
import InfoModal from '../../InfoModal/InfoModal';
import AddOnIcon from '../../AddOnIcon/AddOnIcon';
import getBillCreditAmount from '../../ProductAddOn/helpers/getBillCreditAmount';
import creditMessageFormatter from '../../../helpers/creditMessageFormatter';


const ProgramAddOn = ({ addOn, price, rebatePrice, newPrice }) => {

  let prefixMessage = addOn.content.productCardPrefix;



  if (addOn.content.isBillCreditApplicable) {
    const billCreditAmount = getBillCreditAmount(addOn, { rebates: [] }, newPrice, rebatePrice)

    if (billCreditAmount) {
      prefixMessage = creditMessageFormatter(addOn, billCreditAmount.onElecticity, prefixMessage);
    }
  }


  return (
    <div className="price-display__addon">
      <div className="price-display__addon-header">
        <AddOnIcon
          className="price-display__addon-icon"
          type={addOn.content.icon}
        />
        <div className="price-display__addon-price">
          {price}
        </div>
      </div>
      <div className="price-display__addon-description">
        {`${prefixMessage} `}
        <InfoModal
          styleFlag="addon"
          message={addOn.content.modalBody}
          contentLabel={addOn.content.modalContentLabel}
          subheader={addOn.content.modalSubtitle}
          header={addOn.content.title}
          headerIcon={<AddOnIcon type={addOn.content.icon} />}
        >
          {addOn.content.productCardModalTrigger}
        </InfoModal>
        {` ${addOn.content.productCardSuffix}`}
      </div>
    </div>
  )
}


ProgramAddOn.propTypes = {
  addOn: PropTypes.shape({
    content: PropTypes.shape({
      productCardPrefix: PropTypes.string.isRequired,
      productCardModalTrigger: PropTypes.string.isRequired,
      productCardSuffix: PropTypes.string.isRequired,
      modalContentLabel: PropTypes.string.isRequired,
      modalBody: PropTypes.string.isRequired,
      modalSubtitle: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      isBillCreditApplicable: PropTypes.shape({
        message: PropTypes.string,
        value: PropTypes.number
      })
    }).isRequired,
  }).isRequired,
  price: PropTypes.string.isRequired,
  rebatePrice: PropTypes.shape({
    sales: PropTypes.shape({
      value: PropTypes.number
    })
  }),
  newPrice: PropTypes.shape({
    sales: PropTypes.shape({
      value: PropTypes.number
    })
  })
  // rebateValue:PropTypes.number
};

export default ProgramAddOn;
